'use strict';

const notImplementedError = Error('Not implemented');

export default class iCampaignSettingService {
  getAllCampaignSettings() {
    throw new notImplementedError;
  }
  getCampaignSettingById() {
    throw new notImplementedError;
  }
  addCampaignSetting() {
    throw new notImplementedError;
  }
  updateCampaignSetting() {
    throw new notImplementedError;
  }
}
